import { LanguageSpoken } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<LanguageSpoken>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const jewishDescendantsReducer = createReducer<State, Actions>(initialState, {
  [actions.getJewishDescendants.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getJewishDescendants.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getJewishDescendants.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getJewishDescendants.reset.type]: actionsHandlers.handleGetManyReset,
});

export default jewishDescendantsReducer;
